<div mat-dialog-title>
  <div>
    <h1 *ngIf="formMode === 'registration'">{{ 'LOGIN.REGISTER' | translate }}</h1>
    <h1 *ngIf="formMode === 'edit-profile'">{{ 'PROFILE_MENU.EDIT_PROFILE' | translate }}</h1>
  </div>
  <button mat-icon-button mat-dialog-close [disabled]="isSubmitting">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.GREETING' | translate }}</mat-label>
      <mat-select formControlName="greeting" [required]="settings.Checkout.RequireGreeting">
        <mat-option *ngIf="!settings.Checkout.RequireGreeting">-</mat-option>
        <mat-option value="Herr">{{ 'PROFILE.GREETING_OPTIONS.HERR' | translate }}</mat-option>
        <mat-option value="Frau">{{ 'PROFILE.GREETING_OPTIONS.FRAU' | translate }}</mat-option>
        <mat-option *ngIf="settings.Checkout.GreetingCompany" value="Firma">{{ 'PROFILE.COMPANY' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.COMPANY' | translate }}</mat-label>
      <input matInput formControlName="company" maxlength="100" autocomplete="organization" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.FIRST_NAME' | translate }}</mat-label>
      <input matInput formControlName="firstName" maxlength="25" autocomplete="given-name" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.LAST_NAME' | translate }}</mat-label>
      <input matInput formControlName="lastName" maxlength="25" autocomplete="family-name" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.STREET' | translate }}</mat-label>
      <input matInput formControlName="street" maxlength="255" autocomplete="street-address" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.ZIP' | translate }}</mat-label>
      <input matInput formControlName="zip" maxlength="20" autocomplete="postal-code" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.CITY' | translate }}</mat-label>
      <input matInput formControlName="city" maxlength="50" autocomplete="address-level2" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'EMAIL' | translate }}</mat-label>
      <input matInput type="email" formControlName="email" [email]="true" maxlength="100" autocomplete="email" required />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'PROFILE.PHONE' | translate }}</mat-label>
      <input matInput type="tel" formControlName="phone" maxlength="50" autocomplete="tel" required />
    </mat-form-field>
    <mat-form-field *ngIf="formMode === 'registration'">
      <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
      <input matInput type="password" formControlName="password" minlength="6" autocomplete="new-password" required />
      <mat-error *ngIf="profileForm.controls.password.hasError('minlength')">
        {{ 'INPUT.MIN_LENGTH' | translate : { n: 6 } }}
      </mat-error>
    </mat-form-field>
    <div *ngIf="formMode === 'registration'">
      <mat-checkbox formControlName="privacyAccepted" required>{{ 'PROFILE.PRIVACY_ACCEPT' | translate }}</mat-checkbox>
    </div>
  </mat-dialog-content>
  <div class="form-errors" *ngIf="profileForm.errors">
    <mat-error *ngIf="profileForm.hasError('serverError')">{{ profileForm.errors['serverError'] }}</mat-error>
  </div>
  <mat-dialog-actions align="end">
    <div *ngIf="formMode === 'registration'" class="already-registered">
      {{ 'PROFILE.ALREADY_REGISTERED' | translate }}?
      <a href="javascript:void(0)" (click)="openLogin()">{{ 'SIGN_IN' | translate }}</a>
    </div>
    <button type="submit" mat-raised-button color="primary" [disabled]="!profileForm.valid || isSubmitting">
      {{ (formMode === 'registration' ? 'PROFILE.CREATE_ACCOUNT' : 'PROFILE.UPDATE_ACCOUNT') | translate }}
    </button>
  </mat-dialog-actions>
</form>
